<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold pr-5">
        {{ t('manageEnrollment.spedExitDate.title') }}
      </h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    <div mat-dialog-content>
  		<p class="mt-2">{{ t('manageEnrollment.spedExitDate.exitDateRatingPeriodNote') }}</p>
      <form class="grid grid-cols-2 gap-4" [formGroup]="spedExitDateForm">
        <div class="col-span-1 mt-2">
          <label class="font-normal mb-2" for="childName">{{ t('manageEnrollment.spedExitDate.childNameLabel') }}</label>
          <!-- Child name is server-supplied. -->
          <p>
            {{ child.firstName + " " + child.lastName }}
          </p>
        </div>

        <div class="col-span-1 mt-2">
          <drdp-date-picker [label]="t('manageEnrollment.spedExitDate.entryDateLabel')"
            [initialDate]="spedExitDateForm.get('spedEntryDate').value" [isRequired]="true"
            (emitDate)="handleEntryDate($event)">
          </drdp-date-picker>
        </div>


        <div class="col-span-1 mt-2">
          <drdp-date-picker [label]="t('manageEnrollment.spedExitDate.exitDateLabel')" [initialDate]="spedExitDateForm.get('spedExitDate').value"
            [isRequired]="true" [minDate]="spedExitDateForm.get('spedEntryDate').value" (emitDate)="handleExitDate($event)">
          </drdp-date-picker>
        </div>

      </form>
    </div>
  </div>
  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('manageEnrollment.myClasses.actions.cancel') }}</drdp-btn>
    <drdp-btn class="ml-3" mat-button [disabled]="spedExitDateForm.invalid || isProcessing || !validDate" cdkFocusInitial
      (click)="onSubmit()">{{ t('manageEnrollment.myClasses.actions.save') }}
    </drdp-btn>
  </div>
</ng-container>
